import React from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, BookOpen } from 'lucide-react';
import { LessonModuleContent } from '../components/modules/lesson';

export default function LessonPage() {
  const { contextId } = useParams<{ contextId: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const moduleId = searchParams.get('moduleId');
  const moduleName = searchParams.get('moduleName');

  const handleBack = () => {
    if (contextId) {
      navigate(`/my-courses/course-details/${contextId}`);
    } else {
      navigate(-1);
    }
  };

  if (!moduleId) {
    return (
      <div className="p-6">
        <div className="text-center">
          <p className="text-red-600">Module ID is required</p>
          <Button onClick={handleBack} variant="outline" className="mt-4">
            Go Back
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-4">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Button onClick={handleBack} variant="ghost" size="sm">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Course
        </Button>
      </div>

      {/* Title */}
      <div className="bg-gradient-to-r from-purple-600 to-indigo-600 rounded-lg p-6 text-white shadow-lg">
        <div className="flex items-center gap-3">
          <BookOpen className="h-8 w-8" />
          <div>
            <h1 className="text-2xl font-bold">{moduleName || 'Lesson'}</h1>
            <p className="text-sm opacity-90 mt-1">Interactive Lesson Content</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <LessonModuleContent
        contextId={contextId || ''}
        moduleId={moduleId}
        module={null}
      />
    </div>
  );
}
